import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../context/LanguageContext';

const CtaSection = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  
  return (
    <section className="section" style={{ 
      backgroundColor: 'white',
      padding: '6rem 0',
      position: 'relative',
      overflow: 'hidden'
    }}>
      {/* Background Decorations */}
      <div className="blob" style={{ 
        top: '-30%', 
        right: '-20%', 
        opacity: 0.07,
        animation: 'blob-animation 35s linear infinite'
      }}></div>
      
      <div className="blob" style={{ 
        bottom: '-30%', 
        left: '-15%', 
        opacity: 0.05,
        animation: 'blob-animation 30s linear infinite reverse'
      }}></div>
      
      <div style={{
        position: 'absolute',
        top: '10%',
        left: '5%',
        width: '200px',
        height: '200px',
        borderRadius: '40% 60% 60% 40% / 60% 30% 70% 40%',
        background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.1) 0%, rgba(255, 107, 0, 0) 100%)',
        animation: 'float 12s ease-in-out infinite',
        zIndex: 1
      }}></div>
      
      <div style={{
        position: 'absolute',
        bottom: '15%',
        right: '8%',
        width: '160px',
        height: '160px',
        borderRadius: '60% 40% 30% 70% / 60% 30% 70% 40%',
        background: 'linear-gradient(135deg, rgba(255, 107, 0, 0.1) 0%, rgba(255, 107, 0, 0) 100%)',
        animation: 'float 8s ease-in-out infinite reverse',
        zIndex: 1
      }}></div>
      
      <div className="bg-pattern" style={{ opacity: 0.03 }}></div>
      
      <div className="container" style={{ 
        position: 'relative', 
        zIndex: 2,
        maxWidth: '1200px',
        margin: '0 auto',
        padding: '0 1.5rem'
      }}>
        <div className="cta-card fade-in" style={{
          background: 'linear-gradient(145deg, #FF6B00 0%, #FF9E40 100%)',
          borderRadius: '24px',
          padding: '0',
          color: 'white',
          position: 'relative',
          overflow: 'hidden',
          boxShadow: '0 25px 50px rgba(255, 107, 0, 0.25)'
        }}>
          {/* Top decorative pattern */}
          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            right: '0',
            height: '8px',
            background: 'linear-gradient(90deg, rgba(255, 255, 255, 0.3) 0%, rgba(255, 255, 255, 0) 100%)',
            zIndex: 3
          }}></div>
          
          {/* Decorative shapes */}
          <div style={{
            position: 'absolute',
            top: '-100px',
            right: '-100px',
            width: '300px',
            height: '300px',
            borderRadius: '50%',
            background: 'radial-gradient(circle, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 70%)',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            bottom: '-80px',
            left: '-50px',
            width: '250px',
            height: '250px',
            borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%',
            background: 'radial-gradient(circle, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 70%)',
            transform: 'rotate(25deg)',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'absolute',
            top: '25%',
            right: '15%',
            width: '60px',
            height: '60px',
            borderRadius: '30% 70% 70% 30% / 30% 30% 70% 70%',
            backgroundColor: 'rgba(255, 255, 255, 0.1)',
            transform: 'rotate(25deg)',
            animation: 'float 7s ease-in-out infinite',
            zIndex: 1
          }}></div>
          
          <div style={{
            position: 'relative',
            zIndex: 2,
            padding: '4rem'
          }}>
            <div className="grid" style={{ 
              display: 'grid',
              gridTemplateColumns: 'repeat(12, 1fr)', 
              gap: '3rem',
              alignItems: 'center'
            }}>
          <div className="col-span-7 md-col-span-12">
            <span style={{
              display: 'inline-block',
              padding: '0.5rem 1.5rem',
              backgroundColor: 'rgba(255, 255, 255, 0.2)',
              color: 'white',
              borderRadius: '30px',
              fontWeight: '600',
              fontSize: '0.875rem',
              marginBottom: '1.5rem',
              textTransform: 'uppercase'
            }}>
              {language === 'fr' ? 'COMMENCEZ MAINTENANT' : 
               language === 'ar' ? 'ابدأ الآن' : 
               'GET STARTED NOW'}
            </span>
            
            <h2 className="fade-in" style={{ 
              color: 'white', 
              marginBottom: '1.5rem',
              fontSize: '3rem',
              fontWeight: '700',
              lineHeight: '1.2',
              textShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
            }}>
              {language === 'fr' 
                ? 'Prêt à transformer vos opérations Pétrole, Gaz et Industrie?' 
                : language === 'ar' 
                  ? 'هل أنت مستعد لتحويل عملياتك البتروكيماوية؟' 
                  : 'Ready to transform your petrochemical operations?'}
            </h2>
            
            <p className="fade-in" style={{ 
              color: 'rgba(255, 255, 255, 0.9)',
              fontSize: '1.25rem',
              marginBottom: '2.5rem',
              lineHeight: '1.7',
              maxWidth: '700px',
              textShadow: '0 1px 2px rgba(0, 0, 0, 0.05)'
            }}>
              {language === 'fr' 
                ? 'Contactez-nous dès aujourd\'hui pour discuter de vos besoins en instrumentation Pétrole, Gaz et Industrie et découvrir comment ASSCO peut vous aider à atteindre vos objectifs avec des solutions de pointe et une expertise inégalée.' 
                : language === 'ar' 
                  ? 'اتصل بنا اليوم لمناقشة احتياجاتك من أجهزة البتروكيماويات واكتشف كيف يمكن لشركة ASSCO مساعدتك في تحقيق أهدافك من خلال الحلول المتطورة والخبرة التي لا مثيل لها.' 
                  : 'Contact us today to discuss your petrochemical instrumentation needs and discover how ASSCO can help you achieve your goals with cutting-edge solutions and unmatched expertise.'}
            </p>
            
            <div className="fade-in" style={{
              display: 'flex',
              gap: '1.5rem',
              flexWrap: 'wrap'
            }}>
              <Link 
                to="/contact" 
                className="btn btn-primary"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.75rem',
                  backgroundColor: 'var(--assco-orange)',
                  color: 'white',
                  padding: '1rem 2.5rem',
                  borderRadius: '100px',
                  fontWeight: '600',
                  fontSize: '1rem',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 10px 15px -3px rgba(255, 107, 0, 0.3), 0 4px 6px -2px rgba(255, 107, 0, 0.1)',
                  position: 'relative',
                  overflow: 'hidden',
                  minWidth: '200px'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = '#e25a00';
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = '0 20px 25px -5px rgba(255, 107, 0, 0.4), 0 10px 10px -5px rgba(255, 107, 0, 0.1)';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'var(--assco-orange)';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 10px 15px -3px rgba(255, 107, 0, 0.3), 0 4px 6px -2px rgba(255, 107, 0, 0.1)';
                }}
                onClick={(e) => {
                  const ripple = document.createElement('span');
                  ripple.classList.add('ripple');
                  e.currentTarget.appendChild(ripple);
                  
                  const rect = e.currentTarget.getBoundingClientRect();
                  const x = e.clientX - rect.left;
                  const y = e.clientY - rect.top;
                  
                  ripple.style.left = `${x}px`;
                  ripple.style.top = `${y}px`;
                  
                  setTimeout(() => {
                    ripple.remove();
                  }, 600);
                }}
              >
                {t('navigation.contact')}
                <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '18px', height: '18px' }} viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                </svg>
              </Link>
              
              <Link 
                to="/services" 
                className="btn btn-outline"
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '0.75rem',
                  backgroundColor: 'transparent',
                  color: 'white',
                  padding: '1rem 2.5rem',
                  borderRadius: '100px',
                  border: '2px solid rgba(255, 255, 255, 0.7)',
                  fontWeight: '600',
                  fontSize: '1rem',
                  textDecoration: 'none',
                  transition: 'all 0.3s ease',
                  minWidth: '200px'
                }}
                onMouseOver={(e) => {
                  e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.borderColor = 'white';
                }}
                onMouseOut={(e) => {
                  e.currentTarget.style.backgroundColor = 'transparent';
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.borderColor = 'rgba(255, 255, 255, 0.7)';
                }}
              >
                {language === 'fr' ? 'Explorer nos services' : 
                 language === 'ar' ? 'استكشاف خدماتنا' : 
                 'Explore our services'}
              </Link>
            </div>
          </div>
          
          <div className="col-span-5 md-col-span-12 contact-card-container">
            {/* 3D contact form visualization */}
            <div style={{
              position: 'relative',
              width: '100%',
              height: '480px',
              perspective: '1000px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}>
              <div style={{
                position: 'relative',
                transform: 'rotate3d(1, 1, 0, 20deg)',
                width: '320px',
                height: '380px',
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                backdropFilter: 'blur(10px)',
                borderRadius: '24px',
                boxShadow: '0 25px 50px rgba(0, 0, 0, 0.2), 0 0 40px rgba(255, 255, 255, 0.1) inset',
                border: '1px solid rgba(255, 255, 255, 0.1)',
                padding: '2rem',
                animation: 'float3d 6s ease-in-out infinite',
                zIndex: 3
              }}>
                {/* Form header */}
                <div style={{
                  marginBottom: '1.5rem',
                  textAlign: 'center'
                }}>
                  <h3 style={{
                    fontSize: '1.25rem',
                    fontWeight: '700',
                    color: 'white',
                    marginBottom: '0.5rem'
                  }}>
                    {language === 'fr' ? 'Contactez-nous' : 
                     language === 'ar' ? 'اتصل بنا' : 
                     'Contact Us'}
                  </h3>
                  <p style={{
                    fontSize: '0.875rem',
                    color: 'rgba(255, 255, 255, 0.7)'
                  }}>
                    {language === 'fr' ? 'Remplissez le formulaire ci-dessous' : 
                     language === 'ar' ? 'املأ النموذج أدناه' : 
                     'Fill out the form below'}
                  </p>
                </div>
                
                {/* Form fields visualization */}
                <div style={{
                  marginBottom: '1rem',
                  position: 'relative'
                }}>
                  <div style={{
                    width: '100%',
                    height: '40px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '8px',
                    marginBottom: '1rem',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                  }}></div>
                  
                  <div style={{
                    width: '100%',
                    height: '40px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '8px',
                    marginBottom: '1rem',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                  }}></div>
                  
                  <div style={{
                    width: '100%',
                    height: '40px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '8px',
                    marginBottom: '1rem',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                  }}></div>
                  
                  <div style={{
                    width: '100%',
                    height: '80px',
                    backgroundColor: 'rgba(255, 255, 255, 0.1)',
                    borderRadius: '8px',
                    marginBottom: '1.5rem',
                    border: '1px solid rgba(255, 255, 255, 0.2)'
                  }}></div>
                  
                  <div style={{
                    width: '100%',
                    height: '45px',
                    backgroundColor: 'var(--assco-orange)',
                    borderRadius: '8px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: 'white',
                    fontWeight: '600',
                    boxShadow: '0 10px 15px -3px rgba(255, 107, 0, 0.3)'
                  }}>
                    {language === 'fr' ? 'Envoyer' : 
                     language === 'ar' ? 'إرسال' : 
                     'Send'}
                  </div>
                </div>
                
                {/* Form decorative elements */}
                <div style={{
                  position: 'absolute',
                  top: '15px',
                  right: '15px',
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: 'var(--assco-orange)'
                }}></div>
                
                <div style={{
                  position: 'absolute',
                  top: '15px',
                  right: '30px',
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 255, 255, 0.5)'
                }}></div>
                
                <div style={{
                  position: 'absolute',
                  top: '15px',
                  right: '45px',
                  width: '8px',
                  height: '8px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(255, 255, 255, 0.5)'
                }}></div>
              </div>
              
              {/* Background floating elements */}
              <div style={{
                position: 'absolute',
                top: '15%',
                right: '15%',
                width: '80px',
                height: '80px',
                borderRadius: '20px',
                border: '2px solid rgba(255, 255, 255, 0.1)',
                transform: 'rotate(15deg)',
                animation: 'float 8s ease-in-out infinite',
                animationDelay: '1s',
                zIndex: 1
              }}></div>
              
              <div style={{
                position: 'absolute',
                bottom: '10%',
                left: '20%',
                width: '60px',
                height: '60px',
                borderRadius: '50%',
                border: '2px solid rgba(255, 255, 255, 0.1)',
                animation: 'float 6s ease-in-out infinite',
                animationDelay: '2s',
                zIndex: 1
              }}></div>
            </div>
          </div>
            </div>
          </div>
        </div>
      </div>
      
      <style jsx>{`
        .ripple {
          position: absolute;
          border-radius: 50%;
          background-color: rgba(255, 255, 255, 0.4);
          transform: scale(0);
          animation: ripple 0.8s linear;
        }
        
        @keyframes ripple {
          to {
            transform: scale(4);
            opacity: 0;
          }
        }
        
        @keyframes float3d {
          0% {
            transform: rotate3d(1, 1, 0, 20deg) translateY(0px);
          }
          50% {
            transform: rotate3d(1, 1, 0, 20deg) translateY(-15px);
          }
          100% {
            transform: rotate3d(1, 1, 0, 20deg) translateY(0px);
          }
        }
        
        @media (max-width: 768px) {
          .md-hidden {
            display: none;
          }
          
          .md-col-span-12 {
            grid-column: span 12;
          }
        }
      `}</style>
    </section>
  );
};

export default CtaSection;
